module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan1-1-2e39149bf084ffa7047580f54a69a0f1.webp";